"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function defer(F) {
    return function (fa) {
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        return F.asks(function (outerE) { return F.asks(function (innerE) { return F.runReader(fa, Object.assign({}, outerE, innerE)); }); });
    };
}
exports.defer = defer;
//# sourceMappingURL=monad-reader.utils.js.map